<template>
  <div class="ui form" ref="form">
    <div class="ui pointing secondary menu">
      <a class="item active" data-tab="general">
        <i class="info icon"></i>
        {{ $t("general") }}
      </a>
      <a class="item" data-tab="data">
        <i class="info icon"></i>
        {{ $t("data") }}
      </a>
      <a class="item" data-tab="listeners">
        <i class="code icon"></i>
        {{ $t("listeners") }}
      </a>
      <a class="item" data-tab="notifications">
        <i class="alert sign icon"></i>
        {{ $t("notifications") }}
      </a>
    </div>
    <div class="ui bottom attached tab segment active" data-tab="general">
      <div class="field">
        <label for>{{ $t("name") }}</label>
        <input type="text" name="name" v-model="setup.name" />
      </div>
      <div class="field">
        <label for>{{ $t("service url") }}</label>
        <div class="ui action input">
          <input type="text" name="service_url" v-model="setup.service_url" />
          <div
            class="ui blue icon button"
            @click="check_service"
            :data-tooltip="$t('get methods')"
            data-position="left center"
          >
            <i class="lightning icon"></i>
          </div>
        </div>
      </div>
      <div class="field">
        <label for>{{ $t("method") }}</label>
        <div class="ui action input">
          <select
            class="ui fluid dropdown"
            name="method"
            v-model="setup.method"
            ref="method_dropdown"
          >
            <option :value="mthd" v-for="(mthd, idx) in setup.wsdl_methods" :key="idx">{{ mthd }}</option>
          </select>
          <button
            class="ui blue icon button"
            @click="check_method"
            ref="info_button"
            data-position="left center"
            :data-tooltip="$t('get method info')"
          >
            <i class="info icon"></i>
          </button>
          <div class="ui fluid popup top left transition hidden">
            <div class="ui two column divided center aligned grid">
              <div class="column">
                <h4 class="ui dividing header">{{ $t("request") }}</h4>
                <pre style="text-align:left">{{ method_info ? method_info.request : "" }}</pre>
              </div>
              <div class="column">
                <h4 class="ui dividing header">{{ $t("response") }}</h4>
                <pre style="text-align:left">{{ method_info ? method_info.response : ""}}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="data">
      <div class="ui info message" style="display: block">
        <div class="header">{{ $t("hints") }}</div>
        <ul class="list">
          <li v-html="$t('below options sould be an object according to wsdl documentation')"></li>
        </ul>
      </div>
      <!-- <div class="field">
        <label for>{{ $t("arguments") }}</label>
        <editor @init="init_editor('json')" v-model="setup.arguments" lang="json" theme="monokai"></editor>
      </div>-->
      <div class="field">
        <label for>{{ $t("options") }}</label>
        <editor @init="init_editor('json')" v-model="setup.options" lang="json" theme="monokai"></editor>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="listeners">
      <div class="ui info message" style="display: block">
        <div class="header">{{ $t("hints") }}</div>
        <ul class="list">
          <li v-html="$t('use D to refer data objects')"></li>
          <li v-html="$t('use T to refer task data')"></li>
          <li
            v-html="$t('set arguments like this: <pre>T.args = { arg1: value1, arg2: value2 }</pre>')"
          ></li>
          <li v-html="$t('result of service call is in <pre>T.result</pre>')"></li>
        </ul>
      </div>
      <div class="field">
        <label for>{{ $t("on before send") }}</label>
        <editor
          @init="init_editor('javascript')"
          v-model="setup.listeners.on_before_send"
          lang="javascript"
          theme="monokai"
        ></editor>
      </div>
      <div class="field">
        <label for>{{ $t("on finish") }}</label>
        <editor
          @init="init_editor('javascript')"
          v-model="setup.listeners.on_finish"
          lang="javascript"
          theme="monokai"
        ></editor>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="notifications">
      <notifications-manager :events="events" :notifications="setup.notifications" />
    </div>
    <button class="ui green labeled icon fluid button" type="button" @click="ok">
      <i class="ui check icon"></i>
      {{ $t("ok") }}
    </button>
    <div class="ui error message"></div>
    <template v-for="(mdl, index) in modals">
      <component :is="mdl" :key="index" :setup="setup" @hidden="clear_modals"></component>
    </template>
  </div>
</template>

<script>
import Editor from "vue2-ace-editor";
import { local_api, stringify } from "@/utils";
import NotificationsManager from "../NotificationsManager";
import { isEmpty, cloneDeep } from "lodash";
import InfoModal from "./WSDLMethodInfoModal";

export default {
  name: "UserTaskElementSidebar",
  components: { Editor, NotificationsManager },
  data() {
    return {
      setup: {
        name: "",
        service_url: "",
        method: "",
        wsdl_methods: [],
        options: "",
        // arguments: "",
        listeners: {
          on_before_send: "",
          on_finish: ""
        },
        notifications: []
      },
      events: [
        { display: this.$t("end"), value: "end" },
        { display: this.$t("start"), value: "start" }
      ],
      form: undefined,
      method_info: undefined,
      modals: []
    };
  },
  props: { process: Object, element: Object, project: Object },
  mounted() {
    let vm = this;
    window
      .jQuery(vm.$el)
      .find(".pointing.menu .item")
      .tab();

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
        service_url: ["empty"],
        method: ["empty"]
      }
    });

    window.jQuery(vm.$refs.method).dropdown({
      onChange(value) {
        vm.setup.method = value;
      }
    });

    let conf = vm.$props.element.ngine_configuration;
    if (!isEmpty(conf)) {
      vm.setup = cloneDeep(conf);
      vm.setup.notifications = vm.setup.notifications || [];

      setTimeout(function() {
        window
          .jQuery(vm.$refs.method_dropdown)
          .dropdown("setup menu", {
            values: conf.wsdl_methods.map(x => {
              return { name: x, value: x };
            })
          })
          .dropdown("set value", conf.method);
      }, 500);
    } else window.jQuery(vm.$refs.method_dropdown).dropdown();
  },
  methods: {
    ok() {
      let isValid = this.form.form("validate form");

      if (isValid) {
        this.$emit("ok", this.setup);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    init_editor(type) {
      require(`brace/mode/${type}`);
      require("brace/theme/monokai");
    },
    check_service() {
      let vm = this;
      local_api(vm, "post", "/ngine_composer/process/do-check-wsdl", {
        u: vm.setup.service_url
      })
        .then(r => {
          vm.setup.wsdl_methods = r;
          setTimeout(() => {
            window
              .jQuery(vm.$refs.method_dropdown)
              .dropdown("setup menu", {
                values: r.map(x => {
                  return { name: x, value: x };
                })
              })
              .dropdown({
                onChange(vl) {
                  vm.setup.method = vl;
                }
              })
              .dropdown("show");
          }, 500);
        })
        .catch(err => {
          vm.$alertify.error(stringify(err));
        });
    },
    check_method() {
      let vm = this;
      if (!vm.setup.method)
        vm.$alertify.warning(vm.$t("select a method first"));
      else {
        vm.modals.push(InfoModal);
      }
    },
    clear_modals() {
      this.modals = [];
    }
  },
  computed: {}
};
</script>

<style>
.hidden {
  display: none !important;
}
</style>
